module.exports = {

  development : false,
  wrapper: {
    url: "https://clienttestapi.eoxvantage.com/"
  },
  ui: {
    url: "https://clienttest.eoxvantage.com/"
  },
  api: {
    url: "https://clienttestapi.eoxvantage.com/"
  },
  keycloakLogin: false,
  keycloak: {
    keycloakRedirectUrl:"https://clienttest.eoxvantage.com/",
    keycloakUrl: "https://keycloakstag.eoxvantage.com/",
    keycloakRealm: "master",
    keycloakClientId: "admin-cli",
  }

}
